import styled from "styled-components";
import { Button as AntButton, Form as AntForm, Input as AntInput } from "antd";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	padding: 20px 16px;

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: center;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 28px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #9f9fa2;
		font-size: 14px;
		font-weight: 200;
		line-height: 17.5px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
    margin-top: 2px;
	}
`;

export const ChangePinTitle = styled.p`
  color: #13100F;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px; /* 156.25% */
`;

export const SubTitle = styled.p`
  color: #8E969F;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 4px;
`;

export const Button = styled(AntButton)`
  position: fixed;
  bottom: 16px;
	width: calc(100% - 32px) !important;
  max-width: calc(480px - 32px);
	height: 52px !important;
	border-radius: 12px !important;
	box-sizing: border-box !important ;
	color: #f7f7f7;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	:hover {
		background-color: #6d1304 !important;
	}
`;

export const Input = styled(AntInput.Password)`
	height: 52px;
	background-color: #FFF;
  border-radius: 12px;
  border: #DFDFDF;
  background: #FFF;

	input {
		font-size: 16px !important ;
		text-align: left !important;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		color: #342309;
	}

	.ant-input {
		font-size: 17px !important;
		background-color: #FFF;
	}

	.ant-input::placeholder {
    color: #8E969F;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
	}

	&&& {
		padding-left: 16px;
	}
  &:focus{
    border: 2px solid #F9DF35;
  }
`;

export const TitleWrapper = styled.div`
	margin: 0 0 32px 16px;
`;
